module.exports = __webpack_public_path__ + "static/img/7.2321028.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/7.png
// module id = ZwsD
// module chunks = 0